module.exports = __webpack_public_path__ + "static/media/einstein-icon-36x36.80afcf88.svg";